import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { IdleTimerProvider } from 'react-idle-timer';

const AutoLogout = () => {
    const [isIdle, setIsIdle] = useState(false);
    const navigate = useNavigate();
    const idleTimeout = 5400 * 60 * 1000; // 15 minutes

    // Logout function
    const handleLogout = () => {
        console.log('Logging out due to inactivity or browser close.');
        localStorage.removeItem("name");
        localStorage.removeItem("role");
        localStorage.removeItem("token");
        localStorage.removeItem("userId");
        navigate('/');
        window.location.reload();
    };

    // Function to reset idle timer and update last active timestamp
    const resetIdleTimer = () => {
        localStorage.setItem('lastActive_ats', Date.now()); // Sync across tabs
        setIsIdle(false); // Reset idle state
    };

    // Sync the last active time across tabs using localStorage
    const syncLastActive_emp = () => {
        const storedLastActive_emp = localStorage.getItem('lastActive_ats');
        if (storedLastActive_emp) {
            resetIdleTimer(); // Reset idle state if activity is detected
        } else {
            console.warn('No lastActive_ats found. Skipping sync for fresh session.');
        }
    };
    useEffect(() => {
        // On fresh load, initialize lastActive_emp if missing
        const storedLastActive_emp = localStorage.getItem('lastActive_ats');
        if (!storedLastActive_emp) {
            localStorage.setItem('lastActive_ats', Date.now()); // Initialize
        }
    
        // Add event listener for cross-tab synchronization
        window.addEventListener('storage', syncLastActive_emp);
    
        return () => {
            window.removeEventListener('storage', syncLastActive_emp);
        };
    }, []);
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            setIsIdle(true); // Trigger idle if no token exists
            return;
        }
    
        const now = Date.now();
        const storedLastActive_emp = localStorage.getItem('lastActive_ats');
    
        // Prevent immediate logout on fresh load
        if (!storedLastActive_emp || now - storedLastActive_emp < idleTimeout) {
            console.log('Session is active, preventing immediate logout.');
            resetIdleTimer();
        } else {
            setIsIdle(true);
        }
    }, []);
    
    useEffect(() => {
    const sessionKey = 'session_active_ats';

    // Check and initialize session status
    if (!sessionStorage.getItem(sessionKey)) {
        sessionStorage.setItem(sessionKey, 'true'); // Set session as active
    }

    // Handle visibility changes for refresh scenarios
    const handleVisibilityChange = () => {
        if (document.visibilityState === 'hidden') {
            sessionStorage.setItem('refresh_flag_ats', 'true');
        } else {
            sessionStorage.removeItem('refresh_flag_ats');
        }
    };

    window.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
        window.removeEventListener('visibilitychange', handleVisibilityChange);
    };
}, []);


    // Fetch regularization settings and handle token expiration
    useEffect(() => {
        const sessionKey = 'session_active_ats';
    
        // Check and initialize session status
        if (!sessionStorage.getItem(sessionKey)) {
            sessionStorage.setItem(sessionKey, 'true'); // Set session as active
        }
    
        // Handle visibility changes for refresh scenarios
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'hidden') {
                sessionStorage.setItem('refresh_flag_ats', 'true');
            } else {
                sessionStorage.removeItem('refresh_flag_ats');
            }
        };
    
        window.addEventListener('visibilitychange', handleVisibilityChange);
    
        return () => {
            window.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    useEffect(() => {
        if (isIdle) {
            handleLogout();
        }
    }, [isIdle]);

    return (
        <IdleTimerProvider
            timeout={idleTimeout}
            onIdle={() => setIsIdle(true)}
            onActive={resetIdleTimer}
            debounce={500} 
        >
            {null}
        </IdleTimerProvider>
    );
};

export default AutoLogout;